"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMemberSSR = exports.fetchMember = exports.getOptions = exports.getHeaders = exports.getAuthCookie = exports.setMemberToSession = exports.getMemberFromSession = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const constants_1 = require("./constants");
const getMemberFromSession = () => {
    const member = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(constants_1.STORAGE_KEY);
    if (!member)
        return undefined;
    return JSON.parse(member);
};
exports.getMemberFromSession = getMemberFromSession;
const setMemberToSession = (member) => {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(constants_1.STORAGE_KEY, JSON.stringify(member));
};
exports.setMemberToSession = setMemberToSession;
const getAuthCookie = (cookie) => {
    const cookies = new universal_cookie_1.default(cookie);
    return cookies.get(constants_1.COOKIE);
};
exports.getAuthCookie = getAuthCookie;
const getHeaders = (cookie) => ({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cookie: `${constants_1.COOKIE}=${cookie}`,
});
exports.getHeaders = getHeaders;
const getOptions = (cookie) => {
    const { email, t } = (0, exports.getMemberFromSession)() || {};
    return {
        body: JSON.stringify({ email, token: t }),
        credentials: 'same-origin',
        headers: (0, exports.getHeaders)(cookie),
        method: 'POST',
    };
};
exports.getOptions = getOptions;
const fetchMember = (baseUrl, cookie) => fetch(`${baseUrl}${constants_1.ENDPOINT}`, (0, exports.getOptions)(cookie))
    .then((res) => {
    return res.json();
})
    .then((payload) => {
    return payload.member;
});
exports.fetchMember = fetchMember;
const fetchMemberSSR = (ctx) => {
    const { req: { headers, socket }, } = ctx;
    const protocol = socket.encrypted ? 'https' : 'http';
    const baseUrl = `${protocol}://${headers.host}`;
    const cookie = (0, exports.getAuthCookie)(headers.cookie);
    return (0, exports.fetchMember)(baseUrl, cookie);
};
exports.fetchMemberSSR = fetchMemberSSR;
